<template>
  <div>
    <div
      class="print-box"
      v-html="printSize == 'A4' ? data.html : data"
      :style="printSize == 'A4' ? 'height: 650px;' : 'height: 490px;'"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "print-box",
  props: {
    data: "",
    print_type: "",
  },
  data() {
    return {
      styleTag: "",
      style_flag: false,
    };
  },
  mounted() {
    if (this.printSize == "A4") this.style_flag = true;
    this.setStyle();
  },
  destroyed() {
    if (this.style_flag == true) {
      this.styleTag.remove();
      this.style_flag = false;
    }
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    printSize() {
      let width = 80;
      this.state.system.settings.print.map((item) => {
        if (this.print_type == "bill_reprint") {
          if (item.name == "bill_reprint") {
            width = item.width;
          }
        } else {
          if (item.name == "bill_print") {
            width = item.width;
          }
        }
      });
      return width;
    },
  },
  methods: {
    setStyle() {
      if (this.style_flag == true) {
        this.styleTag = document.createElement("style");
        this.styleTag.appendChild(document.createTextNode(this.data.style));
        document.head.appendChild(this.styleTag);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/*div {
  margin: 30px 0;
  border: 1px solid #f5f5f5;
}*/

#cool .print-box {
  text-align: center !important;
  background: #fff;
  // height: 550px;
  // height: 650px;
  padding: 10px 0px;
  overflow-y: auto;
  @include custom-scrollbar();
}

.print-box table {
  width: 350px;
}
.print-box .center {
  text-align: center !important;
}
.print-box .left {
  text-align: left !important;
}
.print-box .left pre {
  padding: 0 30px !important;
}
.print-box .right {
  text-align: right;
}
.print-box .right pre {
  padding: 0 30px !important;
}
.print-box td {
  padding: 0 5px;
}
.print-box tbody {
  display: table !important;
  width: inherit;
  word-wrap: break-word;
}
.print-box pre {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
  background-color: #fff;
  padding: 0;
  border: none;
  font-size: 12.5px !important;
  margin-bottom: 5px;
}
</style>
